import { COLOURS } from '../../../common/styles/vars';

export default {
  WARNING: {
    COLOUR: COLOURS.orange.mandarin,
    TEXT: COLOURS.mono.black
  },
  ERROR: {
    COLOUR: COLOURS.red.thunderBird,
    TEXT: COLOURS.mono.white
  }
};